import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as styles from './Event.module.scss';
import { truncateText, convertRToSuperscript } from '../utils/utils';

interface EventProps {
  startDate: string;
  endDate?: string;
  title: string;
  location: string;
  className?: string;
}

export default function Event({
  startDate,
  endDate,
  title,
  location,
}: EventProps): React.ReactElement {
  const { t } = useTranslation();

  const dateStr = endDate
    ? t('events.dates', '{{startDateDay}} to {{endDate}}', {
        startDateDay: startDate.split('-')[2],
        endDate: endDate.split('-').reverse().join('-'),
      })
    : startDate.split('-').reverse().join('-');

  return (
    <div className={styles.event}>
      <span className={styles.date}>
        <FontAwesomeIcon icon={['far', 'calendar']} className={styles.icon} />
        {dateStr}
      </span>
      <span className={styles.title} title={title}>
        {convertRToSuperscript(truncateText(title, 70))}
      </span>
      <span className={styles.location}>
        <FontAwesomeIcon icon="map-marker-alt" className={styles.icon} />
        {location}
      </span>
    </div>
  );
}
